import axios, { AxiosResponse, AxiosError } from 'axios'
import { config } from '@/config'
import { TCSAPIResponse } from '@/types/types'
import { formatResponse } from './helpers/formatResponse'
import {
  SwitchOrganizationRequestBody,
  OrganizationCreateUpdateBody,
  OrganizationsResponse,
  OrganizationAPIKeyData
} from '@/types/organizations'

export const OrganizationAPI = {
  getAll: async (token: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/organizations`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return formatResponse<OrganizationsResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<OrganizationsResponse>(null, error as AxiosError)
    }
  },
  create: async (token: string, body: OrganizationCreateUpdateBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/organizations`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  update: async (token: string, body: OrganizationCreateUpdateBody, orgId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'PATCH',
        url: `${config.apiUrl}/v1/organizations/${orgId}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  delete: async (token: string, orgId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/v1/organizations/${orgId}`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  switchOrganization: async (token: string, body: SwitchOrganizationRequestBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/users/set-current-organization`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: body
      })

      return formatResponse<TCSAPIResponse>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TCSAPIResponse>(null, error as AxiosError)
    }
  },
  getOrgAPIKey: async (token: string, orgId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/organizations/${orgId}/api-keys`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<OrganizationAPIKeyData[]>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<OrganizationAPIKeyData[]>(null, error as AxiosError)
    }
  },
  createOrgAPIKey: async (token: string, orgId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/organizations/${orgId}/api-keys`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {}
      })

      return formatResponse<OrganizationAPIKeyData>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<OrganizationAPIKeyData>(null, error as AxiosError)
    }
  },
  removeOrgAPIKey: async (token: string, orgId: string, apiKeyId: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/v1/organizations/${orgId}/api-keys/${apiKeyId}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse<OrganizationAPIKeyData[]>(response.data, null)
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<OrganizationAPIKeyData[]>(null, error as AxiosError)
    }
  }
}
